import { render, staticRenderFns } from "./Income.vue?vue&type=template&id=df52fcc0&lang=pug&"
import script from "./Income.vue?vue&type=script&lang=ts&"
export * from "./Income.vue?vue&type=script&lang=ts&"
import style0 from "./Income.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports